import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Icon from 'views/Icon';
import { Motion, spring, presets } from 'react-motion';
import classnames from 'classnames';

const DropdownTrigger = ({ trigger }) => {
  return trigger ? trigger : <Icon className="ui-2_menu-dots lg" />;
};

export const Divider = (props) => <div className="dropdown-divider" {...props}></div>;

export const DropdownItem = ({ children }) => (
  <div className="dropdown-content">{children}</div>
);

export const DropdownAnchor = ({ children }) => (
  <div className="dropdown-option">{children}</div>
);

export const DropdownHeader = ({ children }) => (
  <div>
    <DropdownItem>
      <p className="openable--label flush--bottom">{children}</p>
    </DropdownItem>
    <Divider style={{ margin: 0 }}/>
  </div>
);

export const DropdownAction = ({ children, className = '' }) => (
  <div className={classnames('dropdown-option', className)}>
    {children}
  </div>
);

class DropdownContent extends React.Component {
  componentDidMount () {
    this.props.onOpen();
  }

  render () {
    return (
      <Motion defaultStyle={{ opacity: 0 }} style={{ opacity: spring(1, presets.stiff) }}>
        { config =>
          <div className='dropdown-menu' style={{ opacity: config.opacity, zIndex: 9999999, ...this.props.style }}>
            {this.props.children}
          </div>
        }
      </Motion>
    );
  }
}

DropdownContent.defaultProps = {
  onOpen: () => {},
};

DropdownContent.propTypes = {
  onOpen: PropTypes.func,
};

class Dropdown extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.mounted = true;
  }

  componentWillMount () {
    if (this.props.isOpen) {
      this.setState({
        isOpen: true,
      });
    }
    if (this.props.shouldForceChangeOpenState) {
      this.setState({
        isOpen: this.props.forcedOpenState,
      });
    }
  }

  componentWillReceiveProps (nextProps) {
    if (
      (nextProps.shouldForceChangeOpenState != this.props.shouldForceChangeOpenState) ||
      (nextProps.forcedOpenState != this.props.forcedOpenState)
    ) {
      this.setState({
        isOpen: nextProps.forcedOpenState,
      });
    }
  }

  openDropdown () {
    this.setState({
      isOpen: true,
    });
  }

  componentDidMount () {
    document.addEventListener('click', this.handleDocumentClick.bind(this), true);
    document.addEventListener('openDropdown', this.openDropdown.bind(this), false);
  }

  componentWillUnmount() {
    this.mounted = false;
    document.removeEventListener('click', this.handleDocumentClick.bind(this), true);
    document.removeEventListener('openDropdown', this.openDropdown.bind(this), false);
  }

  handleDocumentClick (e) {
    if (!this.state.isOpen || !this.mounted) {
      return;
    }

    // HACK to prevent actionables whithin dropdown closing the dropdown
    // this, however, doesn't factor in clicks happening outside the dropdown
    if (e.target.tagName === 'A' || e.target.parentNode.tagName === 'A') {
      return;
    }

    // TODO this doesn't work for CartItemSummary item with CartUndoItem
    if (!ReactDOM.findDOMNode(this).contains(e.target)) {
      this.setState({
        isOpen: false,
      });
    }
  }

  handleMouseDown (e) {
    if (e.type === 'mousedown' && e.button !== 0) {
      return;
    }

    e.stopPropagation();
    e.preventDefault();

    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render () {
    const dropdownClassNames = classnames(
      this.props.className, 'dropdown', 'v2', {
        'is-open': this.state.isOpen,
      });

    return (
      <div className={dropdownClassNames}>
        <div
          className='dropdown-control'
          onMouseDown={this.handleMouseDown.bind(this)}
          >
          <DropdownTrigger trigger={this.props.trigger} />
        </div>

        { this.state.isOpen ?
          <DropdownContent {...this.props} /> :
          null
        }

      </div>
    );

  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/common/views/Dropdown.v2.js